module.exports = __webpack_public_path__ + "img/txtA.6142a240.png";